<template>

<v-app id="view_pedimento">
<v-container>
    <v-row align="start" class="pa-0" >
        <v-col cols="12" sm="12" lg="12" class="pa-3">
                    <img src="/static/logo_negro.png" alt="proControl" style="height:32px" />
        </v-col>
    </v-row>
    <v-row  v-if="(informacion_codigo!='' && pass_ok)">
        <v-col cols="12" sm="12" lg="12">
            <table width="100%" class="both">
                <tr>
                    <td width="10%" align="right"><b>Maquina no.</b></td>
                    <td width="1%"></td>
                    <td width="89%">{{informacion_codigo['no_maquina']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Línea</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_codigo['linea']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Marca</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_codigo['marca']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Modelo</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_codigo['modelo']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Descripción</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_codigo['descripcion']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Serie</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_codigo['serie']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Observaciones</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_codigo['observaciones']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Edificio</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_codigo['edificio']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>STATUS</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_codigo['estatus']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Planta</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_codigo['planta_referencia']}}</td>
                </tr>
            </table>            
        </v-col>
    </v-row>
    <v-row  class="pa-0" align="start" v-if="pass_ok">
        <v-col cols="4" sm="4" lg="4" class="pa-3 pb-0">
            <v-autocomplete v-model="eltipo" :items="tipos" :hide-no-data="true" :return-object="false" @change="active=[]" label="Tipo" item-text="name" item-value="value">
            </v-autocomplete>
        </v-col>
        <v-col cols="8" sm="8" lg="8" class="pa-3 pb-0">
            <v-autocomplete v-if="eltipo=='de_cfdis'" v-model="active[0]" :items="de_cfdis" :hide-no-data="true" @change="preview" :return-object="true" label="Archivo" item-text="name" >
            </v-autocomplete>
             <v-autocomplete v-if="eltipo=='de_adjuntos'" v-model="active[0]" :items="de_adjuntos" :hide-no-data="true" @change="preview" :return-object="true" label="Archivo" item-text="name" >
            </v-autocomplete>
        </v-col>
    </v-row>

    <v-row align="start" class="pa-0"  >
        <v-col cols="12" sm="12" lg="12" class="pa-5 pt-0 "  >
              <v-flex xs12 style="margin-top:20px" >
                                <v-card class="mx-auto primary" height="620px"  v-if="active.length > 0" >
                                    <v-card-title class="primary white--text" >
                                        <v-icon small class="white--text" >search</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Vista Previa</strong>
                                        </span>
                                    </v-card-title>
                                    <v-card-text>
                                        <br />
                                       
                                        <table class="table table-condensed white--text" >
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <span id="lab_title_file" >Archivo:</span>
                                                        &nbsp;
                                                    </td>
                                                   
                                                    <td><strong>{{active[0].name}}</strong></td>

                                                    <td>
                                                        &nbsp;
                                                    </td>

                                                    <td style="padding-top:5px !important;" >
                                                        
                                                        <v-btn v-if="active[0].file != 'grupo'" rounded color="green" x-small @click="download" title="Descargar" v-tippy>
                                                            <v-icon small>mdi-download</v-icon>Descargar
                                                        </v-btn>
                                                       
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div v-if="active[0].file.toUpperCase() =='XML' || active[0].file.toUpperCase() =='TXT' ||  parseInt(active[0].file)  > 0  || active[0].file.toUpperCase()  =='ERR'" class="global" >
                                            <div class="contenidotxt" >
                                                <pre>{{xmlContent}} </pre>
                                            </div>
                                        </div>

                                        <div id="app" v-if="( active[0].file.toUpperCase() =='PDF') && url!='' " >
                                            <PDFViewer v-bind="{url}" @document-errored="onDocumentErrored" ></PDFViewer>
                                        </div>
                                        <div v-if="active[0].file.toUpperCase() =='JPG' || active[0].file.toUpperCase() =='JPEG'" class="global" >
                                            <div class="contenido" >
                                                <v-img :src="`data:image/jpg;base64,${url}`" max-width="900px" ></v-img>                                                
                                            </div>

                                        </div>
                                        <div v-if="active[0].file.toUpperCase() =='PNG'" class="global" >
                                            <div class="contenido" >
                                                <v-img :src="`data:image/png;base64,${url}`" max-width="900px" ></v-img>
                                            </div>

                                        </div>
                                        <v-alert border="top" colored-border type="info" elevation="2" v-if="active[0].file.toUpperCase() !='PDF'  
                                        && active[0].file.toUpperCase()  !='XML' && active[0].file.toUpperCase()  !='PNG' && active[0].file.toUpperCase()  !='JPG' && active[0].file.toUpperCase()  !='JPEG' && active[0].file.toUpperCase()  !='TXT' 
                                        && active[0].file !=''  && !parseInt(active[0].file)>0  && active[0].file.toUpperCase()  !='ERR' " >Vista previa no disponible.
                                        </v-alert>

                                    </v-card-text>
                                </v-card>
                            </v-flex>
        </v-col>
    </v-row>
    </v-container>

    <v-dialog v-model="modalPass" persistent max-width="250px" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <span class="subheading" >
                        <strong>Código de Acceso</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>                
            </v-card-title>
            <v-card-text>      
                <v-form ref="formpass" lazy-validation> 
                    <v-row justify="center">
                        <v-col cols="12" sm="12" md="12" lg="12" style="text-align:center !important;">
                            <v-text-field label="Código" v-model="codigo_acceso" 
                                ref="ingresapass" v-on:keydown.enter.prevent='1' 
                                @keyup.enter="validaPass()" maxlength="10"
                                :rules="[rules.required]"></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click.native="validaPass()">
                    <v-icon>done</v-icon> Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    
</v-app>
</template>

<script>
import {
    request
} from "http";
import {
    mapState
} from "vuex";
import axios from "axios";
import PDFViewer from "@/components/pdf/PDFViewer.vue";
import beautify from "xml-beautifier";

export default {
    components: {
        PDFViewer
    },
    created() {
        this.rfc_empresa = this.$route.params.rfc_empresa;
        this.id_activo_fijo_nacional = this.$route.params.id_activo_fijo_nacional;
        
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

        let data = {
            rfc: this.rfc_empresa,
            id: this.id_activo_fijo_nacional,            
        };

        axios.post("https://apivucem.econnectpro.mx/activo_fijo/get_datos_af/", data)        
            .then(res => {
                console.log(this.$local_storage.get("id_usuario"));
                //this.search = res.data["no_pedimento"];
                this.registro_qr = res.data;
                this.$local_storage.set("rfc", res.data["rfc"]); 
                if(res.data["layout"]!=undefined && res.data["layout"]!=null && typeof res.data["layout"] === 'object' && Object.keys(res.data["layout"]).length > 0){
                    this.informacion_codigo = res.data["layout"];
                }
                //(15-may-2025): Solicitaron que pida el password siempre que tenga, sin importar si esta iniciada la sesión                
                /*if(this.$local_storage.get("id_usuario") > 0){
                    this.pass_ok = true;
                    this.buscar(this.registro_qr);
                } else {*/
                    //Verificamos si tiene password, debe ingresarlo
                    axios.post(this.$hostname + "s3/get_pass/", {"rfc": res.data["rfc"], "tipo":"af_nacional"})
                    .then(res => {
                        if ((res.data["pass"] && res.data["pass"] != "No")  ){                        
                            this.$root.$dialogLoader.hide();
                            this.modalPass = true;
                            this.pass_ok = false;
                        } else {
                            this.pass_ok = true;
                            this.buscar(this.registro_qr);
                        }
                    }).catch(error => {
                        console.log("Error al get_pass",error);
                        this.$root.$dialogLoader.hide();
                    });
                //}
                
                
            })
            .catch(error => {
                console.log(error);
                this.buscar(this.registro_qr);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Registro no cuenta con información. Favor de verificarlo.",
                    footer: '',
                });           
            });

    },
    methods: {
        validaPass: function(){
            if (this.$refs.formpass.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let data = {
                    "rfc": this.$local_storage.get("rfc"),
                    "codigo": this.codigo_acceso,
                    "tipo":"af_nacional" //(13-08-2024): Solicitaron que AF Nacional, tenga su propio password (antes se usaba el de Etiquetas QR general)
                };

                axios.post(this.$hostname + "reportes_ws/valida_pass_etiqueta/", data)         
                    .then(res => {
                        this.modalPass = false;
                        this.pass_ok = true;
                        this.buscar(this.registro_qr);
                }).catch(error => {
                    console.log(error);                    
                    this.$swal({
                        type: "error",
                        title: "¡Código Incorrecto!",
                        text: "",
                        footer: ""
                    });

                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });


            }
        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        preview() {
            // Para eliminar todo el expediente
            this.borrableExpediente = false;
            if (this.active.length > 0 && Number.isInteger(this.active[0].id) && this.active[0].file == "folder") {
                this.borrableExpediente = true;
            }

            this.borrable = !this.active.length || this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";

            if (!this.active.length || this.active[0].file == "zip" || this.active[0].file == "folder") {
                return undefined;
            }

            if (this.active[0].file.toUpperCase() == "PDF" || this.active[0].file.toUpperCase() == "XML" || this.active[0].file.toUpperCase() == "PNG" || this.active[0].file.toUpperCase() == "JPG" || this.active[0].file.toUpperCase() == "JPEG" || this.active[0].file.toUpperCase() == 'TXT' || parseInt(this.active[0].file) > 0 || this.active[0].file.toUpperCase() == 'ERR') {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                this.xmlError = false;
                var datos = {
                    id: this.active[0].dir,
                    bucket: "production.econnect.ds"
                }
                this.xmlContent = "";
                var result = "";
                axios.post(this.$hostname + 's3/download/', datos)
                    .then((response) => {
                        if (typeof response.data !== 'undefined') {
                            let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                                    type: response.headers["content-type"]
                                }),
                                url = window.URL.createObjectURL(blob);
                            if (this.active[0].file.toUpperCase() == "PDF") {
                                this.url = url;
                            }
                            if (this.active[0].file.toUpperCase() == "XML") {
                                this.xmlContent = beautify(atob(response.data));
                            }
                            if (this.active[0].file.toUpperCase() == 'TXT' || parseInt(this.active[0].file) > 0 || this.active[0].file.toUpperCase() == 'ERR') {
                                this.xmlContent = atob(response.data)
                            }
                            if (this.active[0].file.toUpperCase() == "PNG" || this.active[0].file.toUpperCase() == "JPG" || this.active[0].file.toUpperCase() == "JPEG") {
                                this.url = response.data
                            }
                        } else {
                            this.url = "";

                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                                footer: '',
                            });
                        }
                        this.borrable = this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";
                        this.$root.$dialogLoader.hide();
                    })
                    .catch((error) => {
                        this.url = "";
                        this.xmlContent = ""
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined && error.response.data.mensaje == "Archivo no encontrado") {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                                footer: '',
                            });
                            this.$root.$dialogLoader.hide();
                        } else {
                            this.$swal({
                                type: "info",
                                title: "Importante",
                                text: "El tamaño del archivo no permite mostrarlo en el visor de documentos ¿Desea descargar el archivo?",
                                footer: "",
                                showCancelButton: true,
                                cancelButtonColor: "#d33",
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "Aceptar",
                                cancelButtonText: "Cancelar"
                            }).then(result => {
                                if (result.value) {
                                    this.downloadFileUrl(datos.id);
                                } else {
                                    this.$root.$dialogLoader.hide();
                                }
                            });
                        }
                        this.borrable = this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";

                    });
            }

        },
        download() {
            if (this.active[0].file == "zip" || this.active[0].file == "folder") {
                this.generateZip(this.active[0].dir);
            } else {
                if (this.active[0].file.toUpperCase() == "XML") {
                    this.downloadFile(this.active[0].dir);
                } else {
                    try {
                        if (parseFloat(this.active[0].size) > 3.5) //Si pesa mas de 3.5MB que lo baje por url
                            this.downloadFileUrl(this.active[0].dir);
                        else
                            this.downloadFile(this.active[0].dir);
                    } catch (error) {
                        this.downloadFileUrl(this.active[0].dir);
                    }

                }
            }

        },

        urlUpdated(url) {
            this.documentError = undefined;
            this.url = url;
        },

        onDocumentErrored(e) {
            this.documentError = e.text;
        },

        buscar: function (registro) {
            this.de_cfdis = [];
            this.de_adjuntos = [];
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                        
            var self = this;
            
            if (registro["adjuntos"] && registro["adjuntos"].length > 0) {
                
                registro["adjuntos"].forEach(function (item) {                            
                    
                    var sub = item["filename"].split("_");                                            
                    sub = sub[0] + "/";
                    
                    self.de_adjuntos.push(
                        {id: sub + item["filename"],
                        name: item["filename"],
                        dir: registro["path"] +"adjuntos/"+ item["filename"],
                        file: item["ext"],
                        size: 0,
                        expediente: false}
                    );                         
                });
                
            }  

            if (registro["cfdis"] && registro["cfdis"].length > 0) {
                
                registro["cfdis"].forEach(function (item) {   
                    
                    
                    if(item["type"] == "zip"){//Por el momento solo los type zip tienen archivo xml y pdf en S3
                        var sub = item["filename"].split("_");  
                        var extension = item["filename"].split(".");                    
                        sub = sub[0] + "/";
                        
                        //xml
                        self.de_cfdis.push(
                            {id: sub + item["filename"],
                            name: item["filename"],
                            dir: registro["path"] + item["filename"],
                            file: extension[extension.length - 1],
                            size: 0,
                            expediente: false}
                        );

                        //agregamos tambien el pdf
                        var sub = item["filename"].split("_");
                        var pdf_file = item["filename"].replace(".xml",".pdf").replace(".XML",".pdf");
                        self.de_cfdis.push(
                            {id: sub + pdf_file,
                            name: pdf_file,
                            dir: registro["path"] + pdf_file,
                            file: 'pdf',
                            size: 0,
                            expediente: false}
                        );
                    }
                                                                 
                });
                
            } 
            
            if(registro["adjuntos"] && registro["adjuntos"].length == 0 && registro["cfdis"] && registro["cfdis"].length == 0){
                this.$swal({
                    type: "error",
                    title: "No se encontraron archivos",
                    text: this.id_activo_fijo_nacional,
                    footer: ""
                });
            }
            this.$root.$dialogLoader.hide();              

        },

        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download/', datos)
                .then((response) => {

                    if (typeof response.data !== 'undefined') {

                        let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                                type: response.headers["content-type"]
                            }),
                            url = window.URL.createObjectURL(blob);

                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";

                        a.href = url;
                        var arreglo = key.split("/")
                        a.download = arreglo[arreglo.length - 1];
                        a.click();

                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    this.$root.$dialogLoader.hide();
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                });
        },

        generateZip: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                key: key,
                usuario: this.$local_storage.get("id_usuario"),
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_zip/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        this.$swal({
                            type: "info",
                            title: "Generado...",
                            text: "En breve recibirás una notificación para descargar el ZIP",
                            footer: '',
                        });
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        downloadFileUrl: function (dir) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: dir,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
    },
    data: () => ({
        registro_qr:"",
        id_activo_fijo_nacional:"",
        rfc_empresa:"",
        codigo_acceso:"",
        pass_ok: false,
        modalPass:false,
        id_etiqueta_pedimento_bosch: "",        
        informacion_codigo:"",
        de_pedimentos: [],
        de_coves: [],
        de_cfdis: [],
        de_adjuntos: [],
        eltipo: "de_cfdis",
        tipos: [
            {"name":"CFDIs", "value": "de_cfdis"},
            {"name":"Adjuntos", "value": "de_adjuntos"}
        ],
        fab: false,
        xmlError: false,
        xmlContent: "",
        url: "",
        file: "",
        search: null,
        key: 1,
        active: [],
        sel: null,
        URL: "",
        dialog1: false,
        confirm: false,
        confirmExpediente: false,
        confirmCarpeta: false,
        listado: "",
        files: {
            PDF: "mdi-file-pdf-box",
            PNG: "mdi-file-png-box",
            JPG: "mdi-file-jpg-box",
            TXT: "mdi-file-document-outline",
            XLS: "mdi-file-excel-box",
            XLSX: "mdi-file-excel-box",
            DOCX: "mdi-file-word-box",
            DOC: "mdi-file-word-box",
            XML: "mdi-xml",
            ZIP: "mdi-zip-box"
        },
        tree: [],
        items: [],
        borrable: false,
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        borrableExpediente: false,
        borrableCarpeta: false,
        comentario: "",
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Consultar Expediente",
                disabled: true,
                to: ""
            }
        ],
    })
};
</script>

<style scoped>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: white;
    margin-top: 0px;
}

.error {
    border: 1px solid red;
    background: pink;
    color: red;
    padding: 0.5em 3em;
    display: inline;
}

.box-shadow {
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
}

.overflow-hidden {
    overflow: hidden;
}

@media print {
    body {
        background-color: transparent;
    }

    #app {
        margin: 0;
        padding: 0;
    }
}

.global {
    margin-left: 10px;
    margin-top: 20px;
    height: 480px;
    width: 100%;
    border: 1px solid #ddd;
    background-color: white;
    overflow: scroll;
}

.tree {
    margin-left: 0px;
    margin-top: -20px;
    height: 450px;
    width: 100%;
    border: 1px solid #ddd;
    background-color: white;
    overflow-y: scroll;
}

.contenido {
    padding: 5px;
    font-size: small;
    overflow: auto;
    background-color: white;
}

.contenidotxt {
    padding: 5px;
    font-size: small;
    overflow: auto;
    font-size: 12px !important;
    background-color: white;
}

.v-card__subtitle,
.v-card__text {
    line-height: 0.95rem !important;
}

.v-treeview--dense .v-treeview-node__root {
    min-height: 20px !important;
}

.table {
    font-size: 12px !important;
    margin-bottom: 20px;
}

.v-label {
    font-size: 8px !important;
}
.both {
	border-collapse: collapse !important;
}
</style>
